import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { ProjectsWithFiltersComponent } from '@app/components/projects-with-filters/projects-with-filters.component';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';
import { filter } from 'rxjs';
import {
  isExactProjectsListingUrl,
  ProjectsPageFiltersSyncService,
} from './projects-page-filters-sync.service';

@Component({
  selector: 'app-projects',
  imports: [
    CommonModule,
    TranslatePipe,
    NgbNavModule,
    ProjectsWithFiltersComponent,
  ],
  templateUrl: './projects.component.html',
  styleUrl: './projects.component.scss',
  providers: [ProjectsPageFiltersSyncService],
})
export class ProjectsComponent {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);

  protected active = this.getTabIdByType(
    this.route.snapshot.queryParamMap.get('type'),
  );
  protected syncProjectsPageFilters = signal(
    isExactProjectsListingUrl(this.router.url),
  );

  constructor() {
    this.router.events
      .pipe(
        filter((e): e is NavigationEnd => e instanceof NavigationEnd),
        takeUntilDestroyed(),
      )
      .subscribe(() => {
        this.syncProjectsPageFilters.set(
          isExactProjectsListingUrl(this.router.url),
        );
      });

    this.route.queryParamMap.pipe(takeUntilDestroyed()).subscribe((params) => {
      this.active = this.getTabIdByType(params.get('type'));
    });
  }

  protected onTabChanged(activeId: number): void {
    const type = this.getTypeByTabId(activeId);
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { type },
      queryParamsHandling: 'merge',
    });
  }

  private getTabIdByType(type: string | null): number {
    switch (type) {
      case 'underPreparation':
        return 2;
      case 'closed':
        return 3;
      default:
        return 1;
    }
  }

  private getTypeByTabId(tabId: number): 'public' | 'underPreparation' | 'closed' {
    switch (tabId) {
      case 2:
        return 'underPreparation';
      case 3:
        return 'closed';
      default:
        return 'public';
    }
  }
}
